import React, { useMemo } from 'react';
import TimeAgo from 'react-timeago';
import { Tooltip } from '@plerionhq/design-system';
interface DateWithTooltipProps {
  date: string | Date;
  className?: string;
}

const DateWithTooltip: React.FC<DateWithTooltipProps> = ({
  date,
  className = '',
}) => {
  const dateObj = useMemo(
    () => (typeof date === 'string' ? new Date(date) : date),
    [date],
  );
  const fullDate = dateObj.toLocaleString();
  return (
    <Tooltip className={className} label={fullDate}>
      <span className="underline decoration-gray-500 decoration-dashed underline-offset-2">
        <TimeAgo date={dateObj} />
      </span>
    </Tooltip>
  );
};

export default DateWithTooltip;
